import { render, staticRenderFns } from "./ModalContactList.vue?vue&type=template&id=5bfb035a&lang=pug"
import script from "./ModalContactList.vue?vue&type=script&lang=js"
export * from "./ModalContactList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports